import { render, staticRenderFns } from "./SelectOptionKid.vue?vue&type=template&id=69281123&scoped=true"
import script from "./SelectOptionKid.vue?vue&type=script&lang=js"
export * from "./SelectOptionKid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69281123",
  null
  
)

export default component.exports